function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { array, isArray } from 'vega-util';
import { isArgmaxDef, isArgminDef } from './aggregate';
import { isBinned, isBinning } from './bin';
import { ANGLE, CHANNELS, COLOR, DESCRIPTION, DETAIL, FILL, FILLOPACITY, getMainChannelFromOffsetChannel, getOffsetScaleChannel, HREF, isChannel, isNonPositionScaleChannel, isSecondaryRangeChannel, isXorY, isXorYOffset, KEY, LATITUDE, LATITUDE2, LONGITUDE, LONGITUDE2, OPACITY, ORDER, RADIUS, RADIUS2, SHAPE, SIZE, STROKE, STROKEDASH, STROKEOPACITY, STROKEWIDTH, supportMark, TEXT, THETA, THETA2, TOOLTIP, UNIT_CHANNELS, URL, X, X2, XOFFSET, Y, Y2, YOFFSET } from './channel';
import { binRequiresRange, getFieldDef, getGuide, hasConditionalFieldDef, hasConditionalFieldOrDatumDef, initChannelDef, initFieldDef, isConditionalDef, isDatumDef, isFieldDef, isTypedFieldDef, isValueDef, title, vgField } from './channeldef';
import * as log from './log';
import { isContinuous, isDiscrete, QUANTITATIVE, TEMPORAL } from './type';
import { keys, some } from './util';
import { isSignalRef } from './vega.schema';
export function channelHasField(encoding, channel) {
  var channelDef = encoding && encoding[channel];

  if (channelDef) {
    if (isArray(channelDef)) {
      return some(channelDef, function (fieldDef) {
        return !!fieldDef.field;
      });
    } else {
      return isFieldDef(channelDef) || hasConditionalFieldDef(channelDef);
    }
  }

  return false;
}
export function channelHasFieldOrDatum(encoding, channel) {
  var channelDef = encoding && encoding[channel];

  if (channelDef) {
    if (isArray(channelDef)) {
      return some(channelDef, function (fieldDef) {
        return !!fieldDef.field;
      });
    } else {
      return isFieldDef(channelDef) || isDatumDef(channelDef) || hasConditionalFieldOrDatumDef(channelDef);
    }
  }

  return false;
}
export function channelHasNestedOffsetScale(encoding, channel) {
  if (isXorY(channel)) {
    var fieldDef = encoding[channel];

    if ((isFieldDef(fieldDef) || isDatumDef(fieldDef)) && isDiscrete(fieldDef.type)) {
      var offsetChannel = getOffsetScaleChannel(channel);
      return channelHasFieldOrDatum(encoding, offsetChannel);
    }
  }

  return false;
}
export function isAggregate(encoding) {
  return some(CHANNELS, function (channel) {
    if (channelHasField(encoding, channel)) {
      var channelDef = encoding[channel];

      if (isArray(channelDef)) {
        return some(channelDef, function (fieldDef) {
          return !!fieldDef.aggregate;
        });
      } else {
        var fieldDef = getFieldDef(channelDef);
        return fieldDef && !!fieldDef.aggregate;
      }
    }

    return false;
  });
}
export function extractTransformsFromEncoding(oldEncoding, config) {
  var groupby = [];
  var bins = [];
  var timeUnits = [];
  var aggregate = [];
  var encoding = {};
  forEach(oldEncoding, function (channelDef, channel) {
    // Extract potential embedded transformations along with remaining properties
    if (isFieldDef(channelDef)) {
      var field = channelDef.field,
          aggOp = channelDef.aggregate,
          bin = channelDef.bin,
          timeUnit = channelDef.timeUnit,
          remaining = __rest(channelDef, ["field", "aggregate", "bin", "timeUnit"]);

      if (aggOp || timeUnit || bin) {
        var guide = getGuide(channelDef);
        var isTitleDefined = guide === null || guide === void 0 ? void 0 : guide.title;
        var newField = vgField(channelDef, {
          forAs: true
        });
        var newFieldDef = Object.assign(Object.assign(Object.assign({}, isTitleDefined ? [] : {
          title: title(channelDef, config, {
            allowDisabling: true
          })
        }), remaining), {
          // Always overwrite field
          field: newField
        });

        if (aggOp) {
          var op;

          if (isArgmaxDef(aggOp)) {
            op = 'argmax';
            newField = vgField({
              op: 'argmax',
              field: aggOp.argmax
            }, {
              forAs: true
            });
            newFieldDef.field = "".concat(newField, ".").concat(field);
          } else if (isArgminDef(aggOp)) {
            op = 'argmin';
            newField = vgField({
              op: 'argmin',
              field: aggOp.argmin
            }, {
              forAs: true
            });
            newFieldDef.field = "".concat(newField, ".").concat(field);
          } else if (aggOp !== 'boxplot' && aggOp !== 'errorbar' && aggOp !== 'errorband') {
            op = aggOp;
          }

          if (op) {
            var aggregateEntry = {
              op: op,
              as: newField
            };

            if (field) {
              aggregateEntry.field = field;
            }

            aggregate.push(aggregateEntry);
          }
        } else {
          groupby.push(newField);

          if (isTypedFieldDef(channelDef) && isBinning(bin)) {
            bins.push({
              bin: bin,
              field: field,
              as: newField
            }); // Add additional groupbys for range and end of bins

            groupby.push(vgField(channelDef, {
              binSuffix: 'end'
            }));

            if (binRequiresRange(channelDef, channel)) {
              groupby.push(vgField(channelDef, {
                binSuffix: 'range'
              }));
            } // Create accompanying 'x2' or 'y2' field if channel is 'x' or 'y' respectively


            if (isXorY(channel)) {
              var secondaryChannel = {
                field: "".concat(newField, "_end")
              };
              encoding["".concat(channel, "2")] = secondaryChannel;
            }

            newFieldDef.bin = 'binned';

            if (!isSecondaryRangeChannel(channel)) {
              newFieldDef['type'] = QUANTITATIVE;
            }
          } else if (timeUnit) {
            timeUnits.push({
              timeUnit: timeUnit,
              field: field,
              as: newField
            }); // define the format type for later compilation

            var formatType = isTypedFieldDef(channelDef) && channelDef.type !== TEMPORAL && 'time';

            if (formatType) {
              if (channel === TEXT || channel === TOOLTIP) {
                newFieldDef['formatType'] = formatType;
              } else if (isNonPositionScaleChannel(channel)) {
                newFieldDef['legend'] = Object.assign({
                  formatType: formatType
                }, newFieldDef['legend']);
              } else if (isXorY(channel)) {
                newFieldDef['axis'] = Object.assign({
                  formatType: formatType
                }, newFieldDef['axis']);
              }
            }
          }
        } // now the field should refer to post-transformed field instead


        encoding[channel] = newFieldDef;
      } else {
        groupby.push(field);
        encoding[channel] = oldEncoding[channel];
      }
    } else {
      // For value def / signal ref / datum def, just copy
      encoding[channel] = oldEncoding[channel];
    }
  });
  return {
    bins: bins,
    timeUnits: timeUnits,
    aggregate: aggregate,
    groupby: groupby,
    encoding: encoding
  };
}
export function markChannelCompatible(encoding, channel, mark) {
  var markSupported = supportMark(channel, mark);

  if (!markSupported) {
    return false;
  } else if (markSupported === 'binned') {
    var primaryFieldDef = encoding[channel === X2 ? X : Y]; // circle, point, square and tick only support x2/y2 when their corresponding x/y fieldDef
    // has "binned" data and thus need x2/y2 to specify the bin-end field.

    if (isFieldDef(primaryFieldDef) && isFieldDef(encoding[channel]) && isBinned(primaryFieldDef.bin)) {
      return true;
    } else {
      return false;
    }
  }

  return true;
}
export function initEncoding(encoding, mark, filled, config) {
  var normalizedEncoding = {};

  var _iterator = _createForOfIteratorHelper(keys(encoding)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;

      if (!isChannel(key)) {
        // Drop invalid channel
        log.warn(log.message.invalidEncodingChannel(key));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(UNIT_CHANNELS),
      _step2;

  try {
    var _loop = function _loop() {
      var channel = _step2.value;

      if (!encoding[channel]) {
        return "continue";
      }

      var channelDef = encoding[channel];

      if (isXorYOffset(channel)) {
        var mainChannel = getMainChannelFromOffsetChannel(channel);
        var positionDef = normalizedEncoding[mainChannel];

        if (isFieldDef(positionDef)) {
          if (isContinuous(positionDef.type)) {
            if (isFieldDef(channelDef)) {
              // TODO: nesting continuous field instead continuous field should
              // behave like offsetting the data in data domain
              log.warn(log.message.offsetNestedInsideContinuousPositionScaleDropped(mainChannel));
              return "continue";
            }
          }
        } else {
          // no x/y, replace it with main channel
          channel = mainChannel;
          log.warn(log.message.replaceOffsetWithMainChannel(mainChannel));
        }
      }

      if (channel === 'angle' && mark === 'arc' && !encoding.theta) {
        log.warn(log.message.REPLACE_ANGLE_WITH_THETA);
        channel = THETA;
      }

      if (!markChannelCompatible(encoding, channel, mark)) {
        // Drop unsupported channel
        log.warn(log.message.incompatibleChannel(channel, mark));
        return "continue";
      } // Drop line's size if the field is aggregated.


      if (channel === SIZE && mark === 'line') {
        var fieldDef = getFieldDef(encoding[channel]);

        if (fieldDef === null || fieldDef === void 0 ? void 0 : fieldDef.aggregate) {
          log.warn(log.message.LINE_WITH_VARYING_SIZE);
          return "continue";
        }
      } // Drop color if either fill or stroke is specified


      if (channel === COLOR && (filled ? 'fill' in encoding : 'stroke' in encoding)) {
        log.warn(log.message.droppingColor('encoding', {
          fill: 'fill' in encoding,
          stroke: 'stroke' in encoding
        }));
        return "continue";
      }

      if (channel === DETAIL || channel === ORDER && !isArray(channelDef) && !isValueDef(channelDef) || channel === TOOLTIP && isArray(channelDef)) {
        if (channelDef) {
          // Array of fieldDefs for detail channel (or production rule)
          normalizedEncoding[channel] = array(channelDef).reduce(function (defs, fieldDef) {
            if (!isFieldDef(fieldDef)) {
              log.warn(log.message.emptyFieldDef(fieldDef, channel));
            } else {
              defs.push(initFieldDef(fieldDef, channel));
            }

            return defs;
          }, []);
        }
      } else {
        if (channel === TOOLTIP && channelDef === null) {
          // Preserve null so we can use it to disable tooltip
          normalizedEncoding[channel] = null;
        } else if (!isFieldDef(channelDef) && !isDatumDef(channelDef) && !isValueDef(channelDef) && !isConditionalDef(channelDef) && !isSignalRef(channelDef)) {
          log.warn(log.message.emptyFieldDef(channelDef, channel));
          return "continue";
        }

        normalizedEncoding[channel] = initChannelDef(channelDef, channel, config);
      }
    };

    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return normalizedEncoding;
}
/**
 * For composite marks, we have to call initChannelDef during init so we can infer types earlier.
 */

export function normalizeEncoding(encoding, config) {
  var normalizedEncoding = {};

  var _iterator3 = _createForOfIteratorHelper(keys(encoding)),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var channel = _step3.value;
      var newChannelDef = initChannelDef(encoding[channel], channel, config, {
        compositeMark: true
      });
      normalizedEncoding[channel] = newChannelDef;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return normalizedEncoding;
}
export function fieldDefs(encoding) {
  var arr = [];

  var _iterator4 = _createForOfIteratorHelper(keys(encoding)),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var channel = _step4.value;

      if (channelHasField(encoding, channel)) {
        var channelDef = encoding[channel];
        var channelDefArray = array(channelDef);

        var _iterator5 = _createForOfIteratorHelper(channelDefArray),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var def = _step5.value;

            if (isFieldDef(def)) {
              arr.push(def);
            } else if (hasConditionalFieldDef(def)) {
              arr.push(def.condition);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return arr;
}
export function forEach(mapping, f, thisArg) {
  if (!mapping) {
    return;
  }

  var _iterator6 = _createForOfIteratorHelper(keys(mapping)),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var channel = _step6.value;
      var el = mapping[channel];

      if (isArray(el)) {
        var _iterator7 = _createForOfIteratorHelper(el),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var channelDef = _step7.value;
            f.call(thisArg, channelDef, channel);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      } else {
        f.call(thisArg, el, channel);
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
}
export function reduce(mapping, f, init, thisArg) {
  if (!mapping) {
    return init;
  }

  return keys(mapping).reduce(function (r, channel) {
    var map = mapping[channel];

    if (isArray(map)) {
      return map.reduce(function (r1, channelDef) {
        return f.call(thisArg, r1, channelDef, channel);
      }, r);
    } else {
      return f.call(thisArg, r, map, channel);
    }
  }, init);
}
/**
 * Returns list of path grouping fields for the given encoding
 */

export function pathGroupingFields(mark, encoding) {
  return keys(encoding).reduce(function (details, channel) {
    switch (channel) {
      // x, y, x2, y2, lat, long, lat1, long2, order, tooltip, href, aria label, cursor should not cause lines to group
      case X:
      case Y:
      case HREF:
      case DESCRIPTION:
      case URL:
      case X2:
      case Y2:
      case XOFFSET:
      case YOFFSET:
      case THETA:
      case THETA2:
      case RADIUS:
      case RADIUS2: // falls through

      case LATITUDE:
      case LONGITUDE:
      case LATITUDE2:
      case LONGITUDE2: // TODO: case 'cursor':
      // text, shape, shouldn't be a part of line/trail/area [falls through]

      case TEXT:
      case SHAPE:
      case ANGLE: // falls through
      // tooltip fields should not be added to group by [falls through]

      case TOOLTIP:
        return details;

      case ORDER:
        // order should not group line / trail
        if (mark === 'line' || mark === 'trail') {
          return details;
        }

      // but order should group area for stacking (falls through)

      case DETAIL:
      case KEY:
        {
          var channelDef = encoding[channel];

          if (isArray(channelDef) || isFieldDef(channelDef)) {
            var _iterator8 = _createForOfIteratorHelper(array(channelDef)),
                _step8;

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var fieldDef = _step8.value;

                if (!fieldDef.aggregate) {
                  details.push(vgField(fieldDef, {}));
                }
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          }

          return details;
        }

      case SIZE:
        if (mark === 'trail') {
          // For trail, size should not group trail lines.
          return details;
        }

      // For line, size should group lines.
      // falls through

      case COLOR:
      case FILL:
      case STROKE:
      case OPACITY:
      case FILLOPACITY:
      case STROKEOPACITY:
      case STROKEDASH:
      case STROKEWIDTH:
        {
          // TODO strokeDashOffset:
          // falls through
          var _fieldDef = getFieldDef(encoding[channel]);

          if (_fieldDef && !_fieldDef.aggregate) {
            details.push(vgField(_fieldDef, {}));
          }

          return details;
        }
    }
  }, []);
}